<template>
    <div>
        <div class="mb-2">
            Mit der Funktion „Speichern“ haben Sie die Möglichkeit, die eingegebenen Daten erneut abzurufen. Kopieren Sie sich dazu den angezeigten Link – zum Beispiel in die Lesezeichen Ihres Browsers. Ihre eingegebenen Daten sind in codierter Form in diesem Link gespeichert. Dadurch können Sie jederzeit darauf zugreifen und die Berechnung zum Beispiel an neue oder veränderte Gegebenheiten anpassen.
        </div>
      <!--
        <base-input v-model.trim="hashLink"
                    class="w-full"
                    name="hash_link"
                    ref="hash_link"
                    id="hash_link"
                    :type="'text'" :readonly="true"/>
                    -->
        <span @click="saveToClipboard()" class="text-primary-default mr-2 cursor-pointer hover:text-black">
                Link in Zwischenablage kopieren
        </span>
    </div>
</template>

<script>

export default {
    props: {
        hashLink: {
            type: String,
            default: '',
        }
    },
    setup(props) {

        const saveToClipboard = () => {
            document.getElementById('input_hash_link').select()
            document.execCommand('copy')
        }

        return {
            saveToClipboard
        };
    }
}
</script>

<style scoped>

</style>
